export class Progress {
    constructor(public total: number, public progress: number) {
    }
}
